import { render, staticRenderFns } from "./Preparadas.vue?vue&type=template&id=6eff85e8&scoped=true"
import script from "./Preparadas.vue?vue&type=script&lang=js"
export * from "./Preparadas.vue?vue&type=script&lang=js"
import style0 from "./Preparadas.vue?vue&type=style&index=0&id=6eff85e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff85e8",
  null
  
)

export default component.exports